<template>
  <div class="wrap my-2 mx-4">
    <!--Change Tag-->
    <el-dialog title="Chuyển Thẻ" v-if="showMergeDialog" width="440px" :visible.sync="showMergeDialog"
                :destroy-on-close="true" :show-close="false"
                :close-on-press-escape="false"
                append-to-body
                modal-append-to-body
                :close-on-click-modal="false">
      <MergeTag :deleteTag="deleteTag" :tags="tags" @closeDialog="showMergeDialog=false" />
    </el-dialog>

    <!--Add Tag-->
    <el-dialog :visible.sync="dialogVisible" title="Tạo thẻ mới" 
          v-if="dialogVisible" width="900px" destroy-on-close @close = "resetTag()">
      <div style="height: 100%" class="flex-column d-flex gap-3">
        <div class="px-2 bg-white d-flex flex-1" :class="{ 'box-info-tag': listNewTag.length <= 1 }">
          <div class="flex-1 px-2">
            <div v-if="listNewTag.length <= 1">
              <div class="font-size-14 text-start fw-bolder mb-2">Phân loại :</div>
              <el-card>
                <div>
                  <el-radio v-model="radio" label="all" value="false">
                    <span style="color: #000;">Thường</span>
                  </el-radio>
                  <div v-if="radio === 'all'" 
                    class="text-break text-grey ms-4 mt-1">
                    Tag thường nếu bạn muốn toàn bộ nhân viên xem được tag đã tạo.
                  </div>
                </div>
              </el-card>
              <el-card class="mt-2">
                <div>
                  <el-radio v-model="radio" label="assign" value="true">
                    <span style="color: #000;">Chỉ định</span>
                  </el-radio>
                  <div v-if="radio === 'assign'" 
                    class="text-break text-grey ms-4 mt-1">
                    Chỉ nhân viên được chỉ định mới nhìn thấy liên hệ, 
                    hội thoại được gắn tag mà bạn đã phân quyền.
                  </div>
                </div> 
              </el-card>
              <div class="divider-custom mt-3" />
            </div>
            <div class="d-flex flex-column gap-3 mt-3">
              <div :class="{ 'card-tag': listNewTag.length > 1 }" v-for="(tag,index) in listNewTag" :key="index">
                <div class="font-size-16 fw-bolder d-flex justify-content-between align-items-center" >
                  <div class="d-flex align-items-center gap-2">
                    <span class="font-size-14">Thông tin thẻ ({{ index + 1 }}/{{ listNewTag.length }})</span>
                    <div class="color-tag" v-if="!tag.isOpen" :style="{background : tag.color}"></div>
                  </div>
                  <div v-if="listNewTag.length > 1">
                    <div class="btn" v-if="!tag.isData" @click="removeTag(tag)">
                      <IconV2
                      slot="prefix"
                      color = "grey"
                      name="fa fa-xmark" 
                      />
                    </div>
                    <div v-else>
                      <div class="btn d-flex align-items-center gap-2" v-if="!tag.isOpen" @click="showTag(tag)"> 
                        <span v-if="radio === 'assign'" class="font-size-14 text-grey">Đã chọn {{ tag.employees ? tag.employees.length : 0 }} tài khoản</span>
                        <IconV2
                          size = 'lg'
                          slot="prefix"
                          color = "grey"
                          name="v2-arrow1_drop_down" />
                      </div>
                      <div class="btn" v-if="tag.isOpen" @click="showTag(tag)"> 
                        <IconV2
                          size = 'lg'
                          slot="prefix"
                          color = "grey"
                          name="v2-arrow1_drop_up1" />
                      </div>
                    </div>
                    </div>
                </div>
                <div v-if="tag.isOpen">
                  <el-input v-model="tag.name" class="mt-1" label="Tên" placeholder="Nhập tên thẻ"></el-input>
                  <div class="font-size-14 fw-bolder mt-2">Màu sắc :</div>
                  <div class="d-flex gap-2 mt-1">
                    <div v-for="(color, colorIndex) in colors" :key="colorIndex" @click="handleColorClick(color,index)">
                      <div class="tag-option">
                        <el-avatar
                          shape="square"
                          v-bind:style="{ background: color }"
                          :class="{ 'border-color': tag.color == color }"
                          class="clickable"
                        ></el-avatar>
                        <div v-if="tag.color == color" class="selected-tag-icon">
                          <i class="el-icon-check font-size-20 fw-bold text-white"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2" v-if="radio === 'assign'">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <span class="account-assign">Tài khoản chỉ định ({{ tag.employees ? tag.employees.length : 0 }})</span>
                      <div class="search-input d-flex align-item-center">
                        <IconV2
                          slot="prefix"
                          color = "grey200"
                          name="v2-search" />
                        <el-input class="me-2" size="medium" style="width: 250px;border: none;" v-model="searchKeyEmployee" @input="searchEmployee()" placeholder="Tìm nhân viên..." />
                      </div>
                    </div>
                    <div class="list-account-assign w-100">
                      <p class="d-flex justify-content-center mt-3" v-if="employeeShow.length === 0">Không tìm thấy nhân viên</p>
                      <div v-else v-for="(employee, index) in employeeShow" :key="employee.username">
                        <el-checkbox 
                          class="w-100 pt-1 pb-3"
                          :label="employee.username"
                          :checked="isEmployeeSelected(tag, employee)"
                          @change="toggleEmployeeSelection(tag, employee)"
                        >
                          <img class="img-account-assign" src="/assets/icon/ic_user.svg" alt="img-account-assign">
                          <span class="name-account-assign ps-3">{{ employee.username }}</span>
                        </el-checkbox>
                        <div class="divider-custom mb-2" v-if="index < employees.length - 1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-quick-tag d-flex align-items-center mt-2" >
          <div class="flex-grow-1 d-flex align-items-center  gap-2" @click="addNewTag()">
            <IconV2
              slot="prefix"
              color = "primary"
              name="v2-add" />
            <span>Bấm để thêm nhanh một thẻ khác</span>
          </div>
          <el-tooltip class="item" effect="dark" content="Bấm để thêm nhanh một thẻ mới cùng phân loại" placement="top">
            <div>
              <IconV2
                slot="prefix"
                color = "primary"
                name="v2-info2" />
            </div>
          </el-tooltip>
        </div>
        <div class="d-flex flex-row-reverse align-items-center justify-content-between float-end">
          <div>
            <el-button size="medium" type="grey100" plain @click="resetTag()">Hủy</el-button>
            <el-button @click="createTag()" size="medium" type="primary">Xong</el-button>
          </div>
          <span v-if="radio === 'assign'" class="font-size-14 text-grey">Tài khoản chỉ định sẽ nhìn thấy hội thoại được gắn thẻ này.</span>
        </div>
      </div>
    </el-dialog>

    <!--Edit Tag-->
    <el-dialog :visible.sync="dialogEdit" title="Chỉnh sửa thẻ" v-if="dialogEdit" width="600px"
                destroy-on-close @close = "resetTag()">
      <div class="h-100 d-flex flex-column">
        <div class="mb-3">
          <div class="font-size-14 text-start fw-bolder mb-2">Phân loại :</div>
          <el-card>
            <div>
              <el-radio v-model="radio" label="all" value="false">
                <span style="color: #000;">Thường</span>
              </el-radio>
              <div v-if="radio === 'all'" 
                class="text-break text-grey ms-4 mt-1">
                Tag thường nếu bạn muốn toàn bộ nhân viên xem được tag đã tạo.
              </div>
            </div>
          </el-card>
          <el-card class="mt-2">
            <div>
              <el-radio v-model="radio" label="assign" value="true">
                <span style="color: #000;">Chỉ định</span>
              </el-radio>
              <div v-if="radio === 'assign'" 
                class="text-break text-grey ms-4 mt-1">
                Chỉ nhân viên được chỉ định mới nhìn thấy liên hệ, 
                hội thoại được gắn tag mà bạn đã phân quyền.
              </div>
            </div> 
          </el-card>
        </div>
        <el-input v-model="selectedTag.name" class="mt-1" label="Tên" placeholder="Nhập tên thẻ"></el-input>
        <div class="font-size-14 fw-bolder mt-2">Màu sắc :</div>
        <div class="d-flex gap-2 mt-1">
          <div v-for="(color, colorIndex) in colors" :key="colorIndex" @click="handleColorClick(color)">
            <div class="tag-option">
              <el-avatar
                shape="square"
                v-bind:style="{ background: color }"
                :class="{ 'border-color': selectedTag.color == color }"
                class="clickable"
              ></el-avatar>
              <div v-if="selectedTag.color == color" class="selected-tag-icon">
                <i class="el-icon-check font-size-20 fw-bold text-white"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2" v-if="radio == 'assign'">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="account-assign">Tài khoản chỉ định ({{ selectedEmployees.length }})</span>
            <div class="search-input d-flex align-item-center">
              <IconV2
                slot="prefix"
                color = "grey200"
                name="v2-search" />
              <el-input class="me-2" size="medium" style="width: 250px;border: none;" v-model="searchKeyEmployee" @input="searchEmployee()" placeholder="Tìm nhân viên..." />
            </div>
          </div>
          <div class="list-account-assign w-100">
            <p class="d-flex justify-content-center mt-3" v-if="employeeShow.length === 0">Không tìm thấy nhân viên</p>
            <div v-for="(employee, index) in employeeShow" :key="employee.username">
              <el-checkbox
                class="w-100 pt-1 pb-3"
                :label="employee.username"
                :value = "employee.username"
                v-model="selectedEmployees"
              >
                <img class="img-account-assign" src="/assets/icon/ic_user.svg" alt="img-account-assign">
                <span class="name-account-assign ps-3">{{ employee.username }}</span>
              </el-checkbox>
              <div class="divider-custom mb-2" v-if="index < employees.length - 1" />
            </div>
          </div>
        </div>
        <div class="d-flex flex-row-reverse align-items-center justify-content-between mt-3">
          <div class="d-flex">
            <el-button size="medium" type="grey100" plain @click="resetTag()">Hủy</el-button>
            <el-button @click="updateTag()" size="medium" type="primary">Hoàn thành</el-button>
          </div>
          <span v-if="radio == 'assign'" class="font-size-14 text-grey" style="max-width: 255px;">Tài khoản chỉ định sẽ nhìn thấy hội thoại được gắn thẻ này.</span>
        </div>
      </div>
    </el-dialog>

    <!--Sort Tag-->
    <el-dialog :visible.sync="dialogSort" title="Sắp xếp vị trí tag" v-if="dialogSort" width="600px"
                destroy-on-close>
      <div class="flex-column d-flex">
        <div style="min-height: 400px;max-height: 400px;overflow-y: auto">
          <draggable v-model="tags" class="flex-column mt-2" @end="finishSwap">
            <div v-for="(item, index) in tags" :key="'Tag-' + index" style="float:left; margin-bottom: 2px">
              <el-tag
                size="md"
                v-bind:style="{ 'border-radius': '4px', border: '1px solid', color: item.color, 'background-color': setTransparencyHex(item.color,0.1), 'border-color': item.color, margin: '4px' ,'height':'40px','padding':'4px 12px'}"
                effect="dark"
                class="pointer"
              >
                <div class="font-size-14 fw-semibold text-center"
                      style="border-radius: 2px">
                  ({{ index + 1 }}) {{ item.name }}
                </div>
              </el-tag>
            </div>
          </draggable>
        </div>
        <div class="font-size-15 text-danger">Lưu ý: Kéo thả tag vào vị trí bạn muốn.</div>
      </div>
    </el-dialog>

    <!--Delete Tag-->
    <el-dialog class="dialog-delete" :visible.sync="dialogDelete" v-if="dialogDelete" width="300px"
              :close-on-click-modal="false" 
              :show-close="false">
      <div class="flex-column d-flex gap-3">
        <div class="d-flex justify-content-center">
          <IconV2
            size="lg"
            slot="prefix"
            color = "#DEB00C"
            name="v2-info1" />
        </div>
        <div class=" text-center">
          <p style="word-break: keep-all;">Thẻ " <strong class="text-blue">{{ selectedTag.name }}</strong> 
          " hiện đang được gắn cho <strong>{{ getCount(selectedTag.id) }}</strong> hội thoại. 
           Bạn có muốn tiếp tục xoá thẻ không?</p>
        </div>
        <div class="d-flex justify-content-between">
          <el-button size="medium" type="grey100" plain @click="dialogDelete = false">Hủy</el-button>
          <el-button @click="showMerge()" size="medium" type="primary" plain>Chuyển thẻ</el-button>
          <el-button size="medium" type="danger"  @click="deleteTag(selectedTag)">Xóa</el-button>        
        </div>
      </div>
    </el-dialog>

    <!--Table Tag-->
    <div class="mt-3">
      <div class="mb-3">
        <div class="d-flex">
          <div class="fw-bold align-self-center font-size-18 mx-2">Quản lý thẻ</div>
          <div class="flex-1" />
          <div class="search-input d-flex align-item-center me-2">
            <IconV2
              slot="prefix"
              color = "grey"
              name="v2-search" />
            <el-input class="me-2" size="medium" style="width: 250px;border: none;" v-model="searchKey" @input="searchtag()" placeholder="Tìm kiếm thẻ..." />
          </div>
          <el-button size="medium" type="primary" @click="showPopup()" v-if="tags.length > 0">
            + Tạo tag mới
          </el-button>
          <el-button size="medium" plain type="primary" @click="showMergeDialog=true" v-if="tags.length > 0">
            <div class="w-100 d-flex gap-2">
              <IconV2
              slot="prefix"
              color = "primary"
              name="v2-transform" />
              Chuyển thẻ
            </div>
          </el-button>
          <el-button class="btn-arrange" size="medium" plain type="primary" @click="sort()" v-if="tags.length > 0">
            <div class="w-100 d-flex gap-2">
              <IconV2
              slot="prefix"
              color = "primary"
              name="v2-change" />
              Sắp xếp
            </div>
          </el-button>
        </div>
      </div>
      <div class="zalo-account-info-v2">
        <div>
          <div class="d-flex p-3 fw-bold font-size-14 text-grey" style="background: #f4f5f9;">
            <div class="zalo-account-list-item-1 ms-0">Tên thẻ</div>
            <div class="zalo-account-list-item-3 text-center">Số hội thoại đã gắn</div>
            <div class="text-center zalo-account-list-item-3">Ngày</div>
            <div class="text-center zalo-account-list-item-3">Màu sắc</div>
            <div class="zalo-account-list-item-5 text-center">Phân loại</div>
            <div class="zalo-account-list-item-5 text-center" v-if="showActionTag()">Hành động</div>
          </div>
        </div>
        <div class="divider-custom" />

        <div class="zalo-account-list-v2 bg-white p-1" v-if="tags.length > 0">
          <p class="text-center font-size-14 mt-5" v-if="tagShows.length === 0">Không tìm thấy thẻ</p>
          <div v-else v-for="(tag, index) in tagShows" :key="index">
            <div class=" font-size-14">
              <div class="d-flex" style="padding: 12px;">
                <div class="zalo-account-list-item-1 m-auto font-size-16">{{ tag.name }}</div>
                <div  class="zalo-account-list-item-3 m-auto text-center font-size-16">{{ getCount(tag.id) }}</div>
                <div class="text-center zalo-account-list-item-3 m-auto font-size-16">
                  {{ formatDateTimeShort(tag.createAt) }}
                </div>
                <div class="zalo-account-list-item-3 d-flex align-items-center justify-content-center">
                  <el-avatar
                    shape="square"
                    v-bind:style="{ background: tag.color }"
                    :class="{ 'border-color': selectedTag.color == tag.color }"
                    class="clickable"
                  ></el-avatar>
                </div>
                <div class="zalo-account-list-item-5 text-center m-auto ">
                  <TagCustomV2 class="tag-assign font-size-16" :item="getType(tag.assign)" />
                </div>
                <div class="zalo-account-list-item-5 text-center" v-if="showActionTag()">
                  <div class="d-flex h-100 justify-content-center align-item-center">
                    <el-button type="primary" size="mini" 
                      @click="update(tag)"
                      style="padding : 8px;">
                      <div>
                        <IconV2
                          slot="prefix"
                          color = "#ffffff"
                          name="fa fa-pen" />
                      </div>
                    </el-button>
                    <el-button type="grey" size="mini" plain 
                      @click="showDialogDelete(tag)"
                      style="background-color: initial; border-color: grey; padding : 8px" >
                      <div>
                        <IconV2
                          slot="prefix"
                          color = "grey"
                          name="fa fa-trash-can" />
                      </div>
                    </el-button>
                  </div>
                </div>
              </div>

              <div class="divider-custom mx-2" v-if="index < tags.length - 1" />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="d-flex my-4">
            <div style="width: 40px" />
            <div style="width: 60px;height: 60px;">
              <el-image src="/assets/icon/ic_add.svg" />
            </div>
            <div class="justify-content-center text-center flex-1 font-size-14">
              <div>
                Tạo tag giúp bạn phân loại khách hàng, dễ dàng nắm bắt đặc điểm của từng khách hàng
                <br />
                để đưa ra các kế hoạch chăm sóc phù hợp.
              </div>
              <el-button size="medium" type="primary" class="mt-2" @click="showPopup()">Tạo tag ngay
              </el-button>
            </div>
            <div style="width: 70px;height: 30px"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="zalo-account-footer">
      <div class="h-100 d-flex align-item-center gap-5 text-grey">
        <div>
          <span>Tổng: </span>
          <span> {{ countTag }}</span>
        </div>
        <div>
          <span>Thẻ chỉ định: </span>
          <span>{{ countTagAssign }}</span>
        </div>
        <div>
          <span>Thẻ thường: </span>
          <span>{{ countTagNormal }}</span>
        </div>
        <div>
          <span>Số hội thoại đã gắn thẻ: </span>
          <span>{{ countTagConversation }}</span>
        </div>
      </div>    
    </div>
  </div>
</template>
  
<script>
import { HTTP } from "@/lib/http-common";
import MergeTag from "./tag/MergeTag.vue";
import TagCustomV2 from "./common/TagCustomV2.vue";
import IconV2 from "./common/IconV2.vue";


export default {
  components: { 
    MergeTag, 
    TagCustomV2,
    IconV2,
    draggable: () => import("vuedraggable") },
  data() {
    return {
      isOpen :true,
      showMergeDialog: false,
      colors: ["#1895B0", "#E08E0E", "#1769D7", "#FB6321", "#2D8F77", "#CF59AE", "#354662", "#23702B", "#E82B2E", "#7D4DBA"],
      selectedTag: {
        id: null,
        name: '',
        color: '',
        assign: false,
        index: 0,
        employees : []
      },
      tags: [],
      listNewTag : [{ 
        name : '', 
        color : '', 
        assign : false, 
        isOpen : true,
        isData : false,
        employees : []
      }],
      employees: [],
      employeeShow : [],
      radio: "all",
      selectedEmployees: [],
      dialogVisible: false,
      dialogSort: false,
      dialogEdit : false,
      dialogDelete : false,
      listCount: [],
      searchKey:"",
      searchKeyEmployee:"",
      tagShows:[],
      countTag : 0,
      countTagNormal : 0,
      countTagAssign : 0,
      countTagConversation : 0,
    };
  },
  methods: {
    showActionTag() {
      if (this.app.user.type == 'ADMIN') return true;
      let access = false;
      if (this.app.permissions.length > 0) {
        let per = this.app.permissions.filter(p => p.code === "ZALO_MANAGE");
        if (per && per.length > 0) {
          access = true;
        }
      }
      let accessTag = false;
      if (this.app.manageTags) accessTag = true;
      return access && accessTag;
    },
    finishSwap() {
      for (var i = 0; i < this.tags.length; i++) {
        this.tags[i].index = i;
      }
      HTTP.post("/api/tag/swap", this.tags);
    },
    update(tag) {
      this.selectedEmployees = []
      this.selectedTag = JSON.parse(JSON.stringify(tag));
      if(this.selectedTag.assign){
        this.radio = 'assign';
        this.selectedEmployees = this.selectedTag.employees.map(emp => emp.username).filter(username => this.employeeShow.some(emp => emp.username === username));
      }
      else{
        this.radio = 'all';
      }
      this.dialogEdit = true;
    },
    showDialogDelete(tag) {
      this.selectedTag = JSON.parse(JSON.stringify(tag));
      this.dialogDelete = true;
    },
    showMerge(){
      this.showMergeDialog = true;
      this.dialogDelete = false;
    },
    sort() {
      this.dialogSort = true;
    },
    showPopup() {
      this.selectedTag = {
        name: "",
        color: "#1895B0",
        id: 0,
        assign: false,
        employeeList: []
      };
      this.radio = "all";
      this.dialogVisible = true;
    },
    isEmployeeSelected(tag, employee) {
      return tag.employees?.includes(employee.username) || false;
    },
    toggleEmployeeSelection(tag, employee) {
      if (!Array.isArray(tag.employees)) {
        tag.employees = [];
      }
      const index = tag.employees.indexOf(employee.username);
      if (index > -1) {
        tag.employees.splice(index, 1);
      } else {
        tag.employees.push(employee.username);
      }
    },
    addNewTag() {
      if(this.listNewTag && this.listNewTag.length > 0){
        const lastTag = this.listNewTag[this.listNewTag.length-1];

        if(lastTag.name.trim() == '' && lastTag.color.trim() == ''){
          this.alert("error", "Nhập đầy đủ các trường của thẻ !");
        }
        else{
          lastTag.isOpen = false;
          lastTag.isData = true;
          const tagAssign = this.radio === 'all' ? false : true;

          this.listNewTag.forEach(tag => { 
            tag.assign = tagAssign; 
          });
              
          this.listNewTag.push({ 
            name: '', 
            color: '', 
            assign : tagAssign, 
            isOpen : true,
            employees : []
          });
          this.searchKey = '';
        }
      }
    },
    showTag (tag){
      tag.isOpen = !tag.isOpen;
    },
    removeTag(tagToRemove) {
      if(this.listNewTag.length > 0){
        this.listNewTag = this.listNewTag.filter(tag => tag !== tagToRemove);
      }
    },
    resetTag (){
      this.dialogVisible = false;
      this.listNewTag = [{ name : '', color : '', assign : false , isOpen : true}]
      this.selectedEmployees = []; 
      this.dialogEdit = false;
      this.searchEmployee = '';
    },
    handleColorClick(color, index = null) {
      if (index !== null) {
        this.listNewTag[index].color = color;
      } else {
        this.selectedTag.color = color;
      }
    },
    searchtag(){
      if (this.searchKey.length > 0) {
        this.tagShows = this.tags.filter(p => p.name.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.tagShows = this.tags;
      }
    },
    getType(assign) {
      if (assign) return { name: "Chỉ định", color: "#DEB00C" };
      return { name: "Thường", color: "#A3A7AB" };
    },
    async createTag() {
      let errors = this.checkValidListTag(this.listNewTag);
      const tagAssign = this.radio === 'all' ? false : true;

      this.listNewTag.forEach(tag => { 
        tag.assign = tagAssign; 

      });

      if (errors.length > 0) {
        this.alert("error", errors.join(","));
      } else {
        try {
          const res = await HTTP.post("/api/v2/tag/save", this.listNewTag);

          if (res.status === "success") {
            this.alert("success", "Cập nhật thành công!");
            this.fetchAllTag();
            this.dialogVisible = false;
            this.resetAddTag ();
          }
        } catch (res) {
          if (res.error.message.includes("Existed name")) {
            this.alert("error", "Thẻ đã tồn tại. Vui lòng chọn tên khác !");
          } else {
            this.alert("error", "Có lỗi xảy ra!");
          }
        }
      }
    },
    async updateTag() {
      let errors = this.checkValidTag();

      this.selectedTag.employees = [...this.selectedEmployees];
      this.selectedTag.assign = this.radio === 'all' ? false : true;

      if (errors.length > 0) {
        this.alert("error", errors.join(","));
      } else {
        try {
          const res = await HTTP.put("/api/v2/tag/update", this.selectedTag);

          if (res.status === "success") {
            this.alert("success", "Cập nhật thành công!");
            this.fetchAllTag();
            this.dialogEdit = false;
          } else {
            this.alert("error", "Có lỗi xảy ra!");
          }
        } catch (res) {
          if (res.error.message === "Existed name") {
            this.alert("error", "Thẻ đã tồn tại");
          } else {
            this.alert("error", "Có lỗi xảy ra!");
          }
        }
      }
    },
    deleteTag(tag) {
      this.dialogDelete = false;
      HTTP.get("/api/tag/delete", { params: { tagId: tag.id } })
        .then(res => {
          if (res.status === "success") {
            this.alert("success", "Thẻ đã được xóa thành công");
          } else {
            this.alert("error", "Có lỗi xảy ra!");
          }
          this.fetchAllTag();
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra!");
        });
    },
    checkValidListTag(tags) {
      let errors = [];
      
      tags.forEach((tag,index) => {
        if (tag.color.trim() === "") {
          errors.push(`Bạn chưa chọn màu cho thẻ ${index + 1}`);
        }
        if (tag.name.trim() === "") {
          errors.push(`Bạn chưa nhập tên cho thẻ ${index + 1}`);
        }
      });

      return errors;
    },
    checkValidTag() {
      let error = "";
      if (this.selectedTag.color == "") {
        error = "Bạn chưa chọn màu cho thẻ";
      } else if (this.selectedTag.name.trim() == "") {
        error = "Bạn chưa nhập tên cho thẻ";
      }
      return error;
    },
    async fetchAllTag() {
      this.countTagAssign = 0;
      this.countTagNormal = 0;

      let resp = await this.$http.get("/api/v2/tag/tagSetting");
      this.tags = resp.data;
      if (this.tags.length === 0) return;
      if (this.tags.length > 0) {
        this.tags.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        this.getCountConverastionsByTag(this.tags.map(s => s.id));
        this.tagShows = this.tags;
        this.countTag = this.tags.length;
        this.tags.forEach(tag=>{
          if(tag.assign === true){
            this.countTagAssign ++;
          }else{
            this.countTagNormal ++;
          }
        })
      }
    },
    async fetchEmployeeList() {
      HTTP.get("/api/employee/all").then((response) => {
        if (response.status === "success") {
          this.employees = response.data;
          this.employeeShow = this.employees;
        }
      });
    },
    searchEmployee(){
      if (this.searchKeyEmployee.length > 0) {
        this.employeeShow = this.employees.filter(p => p.username.toLowerCase().includes(this.searchKeyEmployee.toLowerCase()));
      } else {
        this.employeeShow = this.employees;
      }
    },
    getCountConverastionsByTag(tagIds) {
      HTTP.post("/api/tag/countConsByTags", tagIds)
      .then(resp => {
        this.listCount = resp.data;
        this.listCount.forEach(item=>{
          this.countTagConversation += item.count;
        })
      }
      
    );
      
      
    },
    getCount(id) {
      let item = this.listCount.find(s => s.id == id);
      if (item) {
        return item.count;
      } else {
        return 0;
      }
    }
  },
  async created() {
    await this.fetchAllTag();
    await this.fetchEmployeeList();
  }
};
</script>

<style>
.wrap{
  font-family: Arial, Helvetica, sans-serif;
}

.tag-container {
  border: 1px solid #dcdfe9;
  box-sizing: border-box;
  border-radius: 4px;
  min-height: calc(100vh - 180px);
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.input-tag {
  width: 200px;
  height: 40px;
}

.tag-option {
  position: relative;
}

.selected-tag-icon {
  position: absolute;
  top: 10px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  text-align: center;
}

.tag-assign{
  border: none!important;;
}

.el-dialog__header{
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
}
.search-input{
  border: 1px #A3A7AB solid;
  border-radius: 4px;
  padding: 0px 8px;
  background-color: #ffffff;
}
.el-input--medium .el-input__inner {
  border: none;
}

.box-info-tag{
  padding: 12px 0;
  border: 1px #EAECF2 solid;
  border-radius: 8px;

}

.card-tag{
  border: 1px #DCDFE9CC solid;
  padding : 4px 12px;
  border-radius: 4px;
}

.color-tag{
  height: 18px;
  width: 18px;
  border-radius: 50%;
}

.account-assign{
  font-size: 14px;
  font-weight: 700;
  color: #373C41;
  line-height: 20px;
  letter-spacing: 1%;
}

.list-account-assign{
  max-height: 180px;
  padding : 4px 16px 4px 12px;
  border: 1px #EAECF2 solid;
  border-radius: 4px;
  overflow-y: auto;
}

.el-checkbox{
  margin-right: 0;
}

.img-account-assign{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px #A3A7AB solid;
}

.name-account-assign{
  font-size: 14px;
  font-weight: 700;
  color: #42444D;
  line-height: 20px;
  letter-spacing: 1%;
}

.add-quick-tag{
  padding: 8px 12px;
  border: 1px #C2DCFF dashed;
  border-radius: 8px;
  color: #3484F0;
  cursor: pointer;
}

.el-card__body{
  padding: 12px;
}

.v2-info1:before{
  font-size: 28px!important;
}

.dialog-delete .el-dialog__header {
  display: none;
}

.tag-assign{
  font-size: 16px!important;
}
.btn-arrange{
  background-color: white !important;
  color: #0A58C0 !important;
  border-color: #9dbce6 !important; 
}
</style>
